module.exports = __webpack_public_path__ + "img/2-2-palma-cultura-festivals.05ed946d.jpg";